import { render, staticRenderFns } from "./TaskFilter.vue?vue&type=template&id=32227204&"
import script from "./TaskFilter.vue?vue&type=script&lang=js&"
export * from "./TaskFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports